<template>
  <div></div>
</template>
<script>
export default {
  name: "PbDropdown",
  props: {},
  methods: {}
};
</script>
<style lang='scss'>
</style>